export default "__VITE_ASSET__CLzHUoFs__"